
new LiveEvent('click', '[data-modal]', function openModal(e) {
  console.log(e)
  e.preventDefault();
  let link = this;
  const modalClass = link.dataset.modalClass;
  let modal = new Modal(this, {
    closerText: '',
    theme: modalClass || 'default',
    onFormSuccess: function () {
      const submitEvent = new CustomEvent('modal-form:success', {
        detail: {
          element: link,
        },
      });
      document.dispatchEvent(submitEvent);
    },
  });
  return false;
});